import { Box } from '@mui/material'
import { emergencies } from '../../../constDatas/constDatas'
import { CONDITION_TYPE_NEW, DISCOUNT_TYPE_AMOUNT, DISCOUNT_TYPE_NA, DISCOUNT_TYPE_PERCENT } from './constants'
import moment from 'moment'

export const formatData = (data) => {
  const formattedData = data?.map((item, index) => {
    return {
      ...item,
      rfqDeadline: item?.rfqDeadline && moment(item?.rfqDeadline).format('DD.MM.YYYY HH:mm'),
      emergency: () => {
        const emergency = emergencies.find((data) => data.value === item?.emergency)

        return (
          <Box display="flex" justifyContent="space-around" alignItems="center" gap={1}>
            <Box sx={{ minWidth: '40px' }}>{emergency.label}</Box>
            {emergency.icon}
          </Box>
        )
      },
      id: index + 1,
    }
  })

  return formattedData
}

export const preCalcRowsDetails = (data, dataId) => {
  const arr = data
    ?.map(({ conversion: conversionRate, ...rest }) => ({
      conversionRate,
      ...rest,
    }))
    .map((item, index) => {
      const isNewRecord = !parseInt(dataId)
      const isAlternativeItem = item?.alternativeItem

      const puom = isNewRecord ? item?.defaultUOM ?? '' : item?.puom ?? item?.defaultUOM ?? ''
      const conversionRate = isNewRecord
        ? isAlternativeItem && item?.uom === item?.defaultUOM
          ? 1
          : item?.uom === item?.defaultUOM
          ? 1
          : 1 // DefaultValue
        : item?.conversionRate ?? 1

      return {
        ...item,
        id: item?.id ?? index + 1,
        bidMainId: isNewRecord ? 0 : item?.bidMainId,
        bidDetailId: isNewRecord ? 0 : item?.bidDetailId,
        rfqDetailId: isNewRecord ? item?.id ?? 0 : item?.rfqDetailId,
        itemCode: item?.itemCode ?? '',
        description: isNewRecord ? item?.itemName2 ?? '' : item?.description ?? '',
        alternativeItemCode: item?.alternativeItemCode ?? '',
        alternativeItemName: item?.alternativeItemName ?? '',
        uom: item?.uom ?? '',
        puom,
        conversionRate,
        lineDescription: item?.lineDescription ?? '',
        condition: { conditionValue: item?.condition ?? 0, disabled: item?.condition === CONDITION_TYPE_NEW },
        rfqQuantity: isNewRecord ? item?.quantity ?? 0 : item?.rfqQuantity ?? 0,
        quantity: item?.quantity ?? 0,
        discountType: item?.discountType ?? 0,
        discountValue: item?.discountValue ?? 0,
        unitPrice: item?.unitPrice ?? 0,
        singleUnitPrice: item?.singleUnitPrice ?? 0,
        totalAmount: item?.totalAmount ?? 0,
        discountedAmount: item?.discountedAmount ?? 0,
        convertedQTY: item?.convertedQTY ?? 0,
        convertedUnitPrice: item?.convertedUnitPrice ?? 0,

        // mockData
        attachments:
          item?.bidDetailId === 1479_123
            ? [
                {
                  attachmentId: 10236,
                  name: '2023-05-28-ferrari-f1-1-59269.jpeg',
                  sourceId: 1384,
                  sourceTypeId: 22,
                  reference: null,
                  extensionType: 'image/jpeg',
                  attachmentTypeId: 0,
                  attachmentSubTypeId: 0,
                  lastModifiedDate: '0001-01-01T00:00:00',
                  size: 957058,
                  file: null,
                  fileLink:
                    'http://116.203.90.202:8080/api/v1/home/module/Bid/fileName/dc073307-08e1-4bbc-8856-606a05fc4c59.jpeg/download',
                  type: 0,
                },
              ]
            : [],
      }
    })

  return arr
}

export const calculationByMainDiscountType = (totalAmount, totalMain, discountValue, discountType) => {
  const data = {
    [DISCOUNT_TYPE_PERCENT]: () => {
      if (discountValue > 100) {
        return
      }

      return {
        discountValue: discountValue,
        discountedAmount: totalAmount - (totalAmount * discountValue) / 100,
      }
    },

    [DISCOUNT_TYPE_AMOUNT]: () => {
      const calculatedDiscountValue = ((((totalAmount ?? 0) * 100) / totalMain) * (discountValue ?? 0)) / 100
      const calculatedDiscountedAmount = (totalAmount ?? 0) - calculatedDiscountValue

      return {
        discountValue: isNaN(calculatedDiscountValue) ? 0 : calculatedDiscountValue.toFixed(2),
        discountedAmount: isNaN(calculatedDiscountedAmount) ? 0 : calculatedDiscountedAmount.toFixed(2),
      }
    },
  }

  return data[discountType]()
}

export const calculationRate = (
  discountedAmount,
  baseRate,
  baseMultiplyOrDivide,
  reportRate,
  reportMultiplyOrDivide,
  isReportEqualsDisCount
) => {
  let baseData = 0
  let reportData = 0

  if (baseMultiplyOrDivide === 0) {
    baseData = discountedAmount * baseRate
  }

  if (baseMultiplyOrDivide === 1) {
    baseData = discountedAmount / baseRate
  }

  if (isReportEqualsDisCount == true) {
    reportData = discountedAmount
  } else {
    if (reportMultiplyOrDivide === 0) {
      reportData = baseData * reportRate
    }

    if (reportMultiplyOrDivide === 1) {
      reportData = baseData / reportRate
    }
  }

  return { discountedBase: baseData.toFixed(2), discountedReporting: reportData.toFixed(2) }
}

export const calculateBidsRow = (row, params) => {
  const discountTypeValue = params.field === 'discountType' ? params?.value ?? 0 : parseInt(row?.discountType ?? 0)

  const calculatedRowByParamObj = {
    totalAmount: {
      [DISCOUNT_TYPE_NA]: {
        totalAmount: params?.value ?? 0,
        unitPrice: (params?.value ?? 0) / (row?.quantity ?? 0),
        discountValue: 0,
        quantity: row?.quantity ?? 0,
        discountedAmount: params?.value ?? 0,
      },

      [DISCOUNT_TYPE_PERCENT]: {
        totalAmount: params?.value ?? 0,
        unitPrice: (params?.value ?? 0) / (row?.quantity ?? 0),
        discountValue: row?.discountValue ?? 0,
        quantity: row?.quantity ?? 0,
        discountedAmount: ((params?.value ?? 0) * (row?.discountValue ?? 0)) / 100,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        totalAmount: params?.value ?? 0,
        unitPrice: (params?.value ?? 0) / (row?.quantity ?? 0),
        discountValue: row?.discountValue ?? 0,
        quantity: row?.quantity ?? 0,
        discountedAmount: (params?.value ?? 0) - (row?.discountValue ?? 0),
      },
    },

    unitPrice: {
      [DISCOUNT_TYPE_NA]: {
        totalAmount: (row?.quantity ?? 0) * (params?.value ?? 0),
        quantity: row?.quantity ?? 0,
        unitPrice: params?.value ?? 0,
        discountValue: 0,
        discountedAmount: (row?.quantity ?? 0) * (params?.value ?? 0),
      },

      [DISCOUNT_TYPE_PERCENT]: {
        totalAmount: (row?.quantity ?? 0) * (params?.value ?? 0),
        quantity: row?.quantity ?? 0,
        unitPrice: params?.value ?? 0,
        discountValue: row?.discountValue ?? 0,
        discountedAmount: ((row?.quantity ?? 0) * (params?.value ?? 0) * (row?.discountValue ?? 0)) / 100,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        totalAmount: (row?.quantity ?? 0) * (params?.value ?? 0),
        quantity: row?.quantity ?? 0,
        unitPrice: params?.value ?? 0,
        discountValue: row?.discountValue ?? 0,
        discountedAmount: (row?.quantity ?? 0) * (params?.value ?? 0) - row?.discountValue ?? 0,
      },
    },

    quantity: {
      [DISCOUNT_TYPE_NA]: {
        totalAmount: (params?.value ?? 0) * (row?.unitPrice ?? 0),
        quantity: params?.value ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: 0,
        discountedAmount: (params?.value ?? 0) * (row?.unitPrice ?? 0),
      },

      [DISCOUNT_TYPE_PERCENT]: {
        totalAmount: (params?.value ?? 0) * (row?.unitPrice ?? 0),
        quantity: params?.value ?? 0,
        unitPrice: row?.unitPrice ?? 0,

        discountValue: row?.discountValue ?? 0,
        discountedAmount: ((params?.value ?? 0) * (row?.unitPrice ?? 0) * row?.discountValue ?? 0) / 100,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        totalAmount: (params?.value ?? 0) * (row?.unitPrice ?? 0) ?? 0,
        quantity: params?.value ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: row?.discountValue ?? 0,
        discountedAmount: (params?.value ?? 0) * (row?.unitPrice ?? 0) - row?.discountValue ?? 0,
      },
    },

    discountedAmount: {
      [DISCOUNT_TYPE_NA]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,

        discountValue: 0,
        discountedAmount: row?.totalAmount ?? 0,
      },

      [DISCOUNT_TYPE_PERCENT]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: ((params?.value ?? 0) / (row?.totalAmount ?? 0)) * 100 ?? 0,
        discountedAmount: params?.value ?? 0,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: (row?.totalAmount ?? 0) - (params?.value ?? 0),
        discountedAmount: params?.value ?? 0,
      },
    },

    discountValue: {
      [DISCOUNT_TYPE_NA]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: 0,
        discountedAmount: row?.totalAmount ?? 0,
      },

      [DISCOUNT_TYPE_PERCENT]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: params?.value ?? 0,
        discountedAmount: (row?.totalAmount ?? 0) - ((row?.totalAmount ?? 0) * (params?.value ?? 0)) / 100,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        totalAmount: row?.totalAmount ?? 0,
        quantity: row?.quantity ?? 0,
        unitPrice: row?.unitPrice ?? 0,
        discountValue: params?.value ?? 0,
        discountedAmount: (row?.totalAmount ?? 0) - params?.value ?? 0,
      },
    },

    discountType: {
      [DISCOUNT_TYPE_NA]: {
        discountValue: 0,
        discountedAmount: row?.totalAmount ?? 0,
      },

      [DISCOUNT_TYPE_PERCENT]: {
        discountValue: 0,
        discountedAmount: 0,
      },

      [DISCOUNT_TYPE_AMOUNT]: {
        discountValue: 0,
        discountedAmount: 0,
      },
    },
  }

  let updateRow = {}

  if (
    params.field === 'discountType' ||
    params.field === 'quantity' ||
    params.field === 'unitPrice' ||
    params.field === 'discountValue' ||
    params.field === 'totalAmount' ||
    params.field === 'discountedAmount'
  ) {
    updateRow = {
      ...row,
      [params.field]: params.value,
      ...calculatedRowByParamObj[params?.field][discountTypeValue],
    }

    return updateRow
  }

  updateRow = {
    ...row,
    [params.field]: params.value,
  }

  return updateRow
}
